module.exports = __webpack_public_path__ + "static/media/007-Earls Yaletown.168a61f8.jpeg";